/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";
import {  } from "relay-runtime";
export type Shipping_item = {
    readonly " $fragmentRefs": FragmentRefs<"useShippingPrice_item">;
    readonly " $refType": "Shipping_item";
};
export type Shipping_item$data = Shipping_item;
export type Shipping_item$key = {
    readonly " $data"?: Shipping_item$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"Shipping_item">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": "",
      "kind": "LocalArgument",
      "name": "buyerId"
    },
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "fetchShippingCostInfo"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "Shipping_item",
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "buyerId",
          "variableName": "buyerId"
        },
        {
          "kind": "Variable",
          "name": "fetchShippingCostInfo",
          "variableName": "fetchShippingCostInfo"
        }
      ],
      "kind": "FragmentSpread",
      "name": "useShippingPrice_item"
    }
  ],
  "type": "Item",
  "abstractKey": null
};
(node as any).hash = '846460cb083eafe82c8a90dfa1e43582';
export default node;
